module.exports = __webpack_public_path__ + "static/img/solu2.d39ea0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu2.jpg
// module id = OWVz
// module chunks = 1